import React from "react";
import { School } from "../components/school/school";

export const SchoolPage = () => {
  return <School />;
};
